/**
 * Test whether or not a value is an object. Identical to (Object.prototype.toString.call(value) === '[object Object]').
 * @param value - The value to evaluate.
 */
export default function isObject(value: unknown): value is Record<string, unknown> {
    return Object.prototype.toString.call(value) === '[object Object]';
}
